import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';
import Icon from './Icon';
import Reveal from './Reveal';
import SectionHead from './SectionHead';
import { solutions } from '../data/solutions';

const InstitutionGrid = ({ showHead = true, alt = false }) => (
  <section className={`section ${alt ? 'section-alt' : ''}`}>
    <div className="container">
      {showHead && (
        <SectionHead
          eyebrow="Who we serve"
          title="Built for every kind of institute"
          subtitle="Choose your institution type to see exactly how Fedigma helps."
        />
      )}
      <Reveal className="institution-grid">
        {solutions.map((solution) => (
          <Link key={solution.id} to={`/solutions/${solution.id}`} className="institution-card">
            <span className="service-icon"><Icon name={solution.icon} /></span>
            <h3>{solution.name}</h3>
            <p>{solution.short}</p>
            <span className="institution-link">
              See how we help <FiArrowUpRight />
            </span>
          </Link>
        ))}
      </Reveal>
    </div>
  </section>
);

export default InstitutionGrid;
